<template>
  <section id="services">
    <description>Wir unterstüzen Sie und Ihre Kunden gerne auch neben der Programmierung der Website.</description>
    <Swiper>
      <tile checkbox-id="livecoding" heading="Live-Entwicklung" input="checkbox" icon-id="livecoding" :contents="livecodingContent" :hints="livecodingHints" />
      <tile checkbox-id="schulung" heading="Schulung" input="checkbox" icon-id="schulung" :contents="schulungContent" :hints="schulungHints" />
      <tile checkbox-id="content" heading="Inhaltseinpflege" input="rangeslider" :rangeMin="0" :rangeMax="100" :step="1" :single-rangeslider="true" rangeLabel="Seitenzahl" icon-id="content" :contents="contentContent" :hints="contentHints" />
      <tile checkbox-id="datensicherung" heading="Datensicherung" input="checkbox" icon-id="datensicherung" :contents="datensicherungContent" :hints="datensicherungHints" />
      <tile checkbox-id="updates" heading="Updates" input="checkbox" icon-id="updates" :contents="updateContent" :hints="updateHints" />
    </Swiper>
    <controller next="/zusammenfassung" nextText="Abschließen" />
    <inclusive-footer />
    <how-to />
    <made />
  </section>
</template>

<script>
import Description from '@/components/Description.vue'
import Swiper from '@/components/Swiper.vue'
import Tile from '@/components/Tile.vue'
import Controller from '@/components/Controller.vue'
import HowTo from '@/components/HowTo.vue'
import InclusiveFooter from '@/components/InclusiveFooter.vue'
import Made from '@/components/Made.vue'
export default {
  components: {
    Description,
    Swiper,
    Tile,
    Controller,
    HowTo,
    InclusiveFooter,
    Made
  },
  data: function () {
    return {
      livecodingContent: [
        { sentence: 'Entwicklung der Website auf einem Ihnen zugänglichen Server' },
        { sentence: 'Erlaubt Ihnen, den Entwicklungsfortschritt live zu verfolgen' }
      ],
      livecodingHints: [
        { sentence: 'Auf Wunsch auf Ihrem eigenen Server bzw. dem Server Ihres Kunden' }
      ],
      schulungContent: [
        { sentence: 'Einführung zur korrekten Benutzung und Pflege der Website via Skype' },
        { sentence: 'Anschließend bis zu 2 Stunden individuelle Fragerunde' }
      ],
      schulungHints: [
        { sentence: 'Auf Wunsch vor Ort (zzgl. Anfahrt)' }
      ],
      contentContent: [
        { sentence: 'Professionelle Einpflege Ihrer Inhalte in die Website' },
        { sentence: 'Eine einzupflegende Seite beinhaltet maximal 2000 Wörter, 10 Bilder, Videos oder Grafiken' }
      ],
      contentHints: [
        { sentence: 'Zu den einzupflegenden Inhalten gehören zum Beispiel Texte, Bilder, Videos oder Grafiken' },
        { sentence: 'Standardmäßig bestücken wir jedes gewählte Template mit Dummy-Content' }
      ],
      datensicherungContent: [
        { sentence: '2 Jahre: Halbjährliche Sicherung aller Daten der Website' },
        { sentence: 'Sowohl Programmcode als auch Datenbanken' }
      ],
      datensicherungHints: [
        { sentence: 'Speicherung in verschlüsselter Datei für Sie zum Download' },
        { sentence: 'Unsere Dienstleistung bleibt wie sonst auch für Ihren Kunden völlig unbemerkt' }
      ],
      updateContent: [
        { sentence: '2 Jahre: Halbjährliches Update des CMS der Website' },
        { sentence: 'Update aller von clickzip installierten Plugins' }
      ],
      updateHints: [
        { sentence: 'Updates werden durchgeführt, sofern daraus keine Inkompatibilitäten resultieren' },
        { sentence: 'Unsere Dienstleistung bleibt wie sonst auch für Ihren Kunden völlig unbemerkt' }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/variables.scss";
#services {
  padding-top: 80px;
}
@media (min-height: 420px) {
  #services {
    padding-bottom: 107px;
  }
}
@media (min-height: 520px) {
  #services {
    padding-bottom: 127px;
  }
}
@media(min-width:767px) {
  #services {
    padding-top: 100px;
  }
}
</style>
